
import Checkbox from '@mui/material/Checkbox';
import { weatherRadioButtons } from '../../../../constants';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useChartTableSelect, useElementRadioSelect, useElementSelection, useWindDirection, useWindSpeed } from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { useHistory, useLocation } from 'react-router';
import { ROUTE_PATHS } from 'src/routes';
import FormControlLabel from '@mui/material/FormControlLabel';

import { ElementSelect } from 'src/types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { buildPath } from 'src/store/common';

const WeatherSelect = ()=>{
    const [state, dispatch] = useStoreContext();
    const selectElement = useElementSelection(dispatch);
    const history = useHistory();
    const location = useLocation(); 
    const radioGlobalSet = useElementRadioSelect(dispatch);
    const selectChartTableType = useChartTableSelect(dispatch);
    const selectWindSpeed = useWindSpeed(dispatch);
    const selectWindDirection = useWindDirection(dispatch);

    useEffect(()=>{
        if(location.search){
            const stringArray = decodeURIComponent(location.search).split("/");
            if (stringArray.length>=9) {
                const element = stringArray[2];
                const mapType = stringArray[0];
                const type = stringArray[1];
                const windDirBool: boolean = stringArray[7]==='true'? true:false;
                const windSpeedBool: boolean = stringArray[8]==='true'? true:false;
                if(type!== state.selectedRadio.type || mapType!==state.selectedRadio.dataType){
                    const findRadio = weatherRadioButtons.find((radioItem)=> radioItem.type === type);
                    if(findRadio){
                        radioGlobalSet(findRadio);
                    }
                }
                if(state.selectedElement?.value!==element){
                    const findWeatherValue = state.selectedRadio.elementSelections?.find((item:any)=> item?.value ===element);
                    if(findWeatherValue){
                        selectElement(findWeatherValue);
                        selectChartTableType(findWeatherValue.defaultChart)
                    }
                }
                if(state.wind_direction!==windDirBool){
                    selectWindDirection(windDirBool)
                }
                if(state.wind_speed!==windSpeedBool){
                    selectWindSpeed(windSpeedBool)
                }
            }
            else{
                if(state.selectedElement===null){
                    selectElement(weatherRadioButtons[0].elementSelections[0]);
                    const paramsForBuildPath = {
                        dataType: state.mapDataType,
                        radio: state.selectedRadio.type,
                        element: weatherRadioButtons[0].elementSelections[0].value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.wind_direction,
                        windOrSub: state.wind_speed
                    }
                    buildPath(paramsForBuildPath, history);
                }
                else{
                    const paramsForBuildPath = {
                        dataType: state.mapDataType,
                        radio: state.selectedRadio.type,
                        element: state.selectedElement?.value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.wind_direction,
                        windOrSub: state.wind_speed
                    }
                    buildPath(paramsForBuildPath, history);
                }
            }
        }
        if(!location.search){
            if(sessionStorage.getItem('path')){
                const path = sessionStorage.getItem('path');
                if(path!==null){
                    history.push({pathname: `${ROUTE_PATHS.home}`, search: path});
                }
            }
            else{
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
        }
        
    },[state.selectedElement, state.selectedBaseMap.id,
        location.search,selectElement, state.currentZoom, history, state.elevationFilterValues , radioGlobalSet,
        selectChartTableType, state.selectedRadio.elementSelections, state.selectedRadio.type, selectWindDirection, selectWindSpeed,
        state.wind_direction, state.wind_speed,state.mapDataType, state.selectedRadio.dataType
    ]);
    
    const handleElementSelect =(elementSelect:any, radio?:any)=>{
        if(radio){
            const findWeatherValue = radio.elementSelections.find((item: ElementSelect)=> item.value ===elementSelect);
            if(findWeatherValue){
                selectElement(findWeatherValue);
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: radio.type,
                    element: findWeatherValue.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
                selectChartTableType(findWeatherValue.defaultChart);
            }

        }
        else{
            const findWeatherValue = state.selectedRadio.elementSelections.find((item: ElementSelect)=> item.value ===elementSelect);
            if(findWeatherValue){
                selectElement(findWeatherValue);
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: findWeatherValue.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
                selectChartTableType(findWeatherValue.defaultChart)
            }
        }

    };
    const handleRadioSelect = (radio: any) => {
        const prevRadio = state.selectedRadio;
        const findRadio = weatherRadioButtons.find((radioItem) => radioItem.type === radio);
        if (findRadio) {
            radioGlobalSet(findRadio);
            if (prevRadio !== radio) {
                handleElementSelect(findRadio.elementSelections[0].value, findRadio)
            }
            else {
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: findRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
        }
    }

    const handleWindDirection = ()=>{
        const changedVal = !state.wind_direction
        selectWindDirection(changedVal);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: state.selectedRadio.type,
            element: state.selectedElement?.value,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: changedVal,
            windOrSub: state.wind_speed
          }
          buildPath(paramsForBuildPath, history);
    }

    const handleWindSpeed = ()=>{
        const changedVal = !state.wind_speed
        selectWindSpeed(changedVal);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: state.selectedRadio.type,
            element: state.selectedElement?.value,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: state.wind_direction,
            windOrSub: changedVal
          }
          buildPath(paramsForBuildPath, history);
    }

    return(
        <div>
            <FormControl>
                <RadioGroup
                    id="weatherData" 
                    name="controlled-radio-buttons-group"
                    value={state.selectedRadio.type}
                    onChange={(event) => { handleRadioSelect(event.target?.value); }}
                >
                    {weatherRadioButtons.map((radioItem: any) =>
                        <FormControlLabel 
                            key={`${radioItem.type}`} 
                            value={radioItem.type} 
                            control={<Radio size='small' style={{padding: '5px'}}/>} 
                            label={<Typography style={{fontSize: '.7rem'}}>{radioItem.label}</Typography>} 
                        />
                    )}
                </RadioGroup>
            </FormControl>
            <Select 
                value={state.selectedElement? state.selectedElement.value:''} 
                onChange={(event) =>handleElementSelect(event.target?.value)}
                id="weatherData" 
                style={{fontSize: 'small', width: '90%', marginTop:'2px', marginBottom: '1px', height: '2rem'}}
                className= "select-styles"
                inputProps={{
                    id: 'weatherData',
                }}
            >
            {state.selectedRadio.elementSelections.map((element:any) =>(
                <MenuItem value = {element.value} key ={`${element.value}`}>
                    {element.label}
                </MenuItem>
            ))}
            </Select>

            <div className='sidebar-section-label' style={{paddingTop: '.75rem'}}>Wind Direction</div>
                <div className='inputContainer' style={{fontSize: 'small', marginTop: '-10px'}}>
                    <FormControlLabel
                        label={<Typography style={{fontSize: 'small'}}>Show Wind Direction Arrows</Typography>}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                        style={{fontSize: '14px'}}
                        control={<Checkbox checked={state.wind_direction} onChange={handleWindDirection} color="success"/>}
                    />
                </div>
                <div className='inputContainer' style={{fontSize: 'small', marginTop:'-15px'}}>
                    <FormControlLabel
                        label={<Typography style={{fontSize: 'small'}}>Show Wind Barbs</Typography>}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                        control={<Checkbox checked={state.wind_speed} onChange={handleWindSpeed} color="success"/>}
                    />

                </div>
            </div>
    )
}
export default WeatherSelect;